import { EnumLike, z } from 'zod';
import { Validation } from '@mews/framework';
import { MultipleRateGroupsUpdateParameters, RateGroupOptions, SettlementExtent } from '@mews-commander/data-access';
import { SettlementConfigurationsFieldName } from '../components/forms/types';

export const createSettlementConfigurationSchema = <SE extends EnumLike, RGO extends EnumLike>({
    settlementExtent,
    rateGroupOptions,
}: {
    settlementExtent: SE;
    rateGroupOptions: RGO;
}) =>
    z.object({
        [SettlementConfigurationsFieldName.MaximumTime]: z
            .union([Validation.Number.MaxPositiveInteger, z.literal('')])
            .nullish(),
        [SettlementConfigurationsFieldName.Extent]: z.array(z.nativeEnum(settlementExtent)).min(1),
        [SettlementConfigurationsFieldName.Options]: z.array(z.nativeEnum(rateGroupOptions)).nullish(),
        [SettlementConfigurationsFieldName.CurrencyCode]: z.string(),
        [SettlementConfigurationsFieldName.RequirePaymentCardDuringOnlineCheckIn]: z.boolean().nullish(),
    });

export const settlementConfigurationSchema = createSettlementConfigurationSchema({
    settlementExtent: SettlementExtent,
    rateGroupOptions: RateGroupOptions,
});

export type SettlementConfigurationFormValues = z.infer<typeof settlementConfigurationSchema>;

export const toSettlementConfigurationEditParameters =
    ({ rateGroupId, serviceId }: { rateGroupId: string; serviceId: string }) =>
    (settlementConfigurations: SettlementConfigurationFormValues): MultipleRateGroupsUpdateParameters => ({
        serviceId,
        rateGroupUpdates: [
            {
                rateGroupId,
                settlementRuleUpdates: [],
                settlementMaximumTimeUnits: { value: settlementConfigurations.maximumTime || null },
                settlementExtent: { value: settlementConfigurations.extent },
                options: { value: settlementConfigurations.options },
            },
        ],
    });
